<template>
  <div>
    <search></search>
    <list></list>
    <modal-code></modal-code>
    <modal-delete-box></modal-delete-box>
  </div>
</template>

<script>
import Search from './components/index/Search.vue';
import List from './components/index/list/Main.vue';
import ModalCode from './components/modal/Code.vue';
import ModalDeleteBox from './components/modal/DeleteBox.vue';

export default {
  components: {
    Search,
    List,
    ModalCode,
    ModalDeleteBox,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Index.vue?19ea8c12
 **/